"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) 2007-2018 GoodData Corporation
exports.REG_URI_OBJ = /\/gdc\/md\/(\S+)\/obj\/\d+/;
exports.isUri = function (identifier) {
  return exports.REG_URI_OBJ.test(identifier);
};
exports.areUris = function (identifiers) {
  return identifiers.every(exports.isUri);
};